import { render, staticRenderFns } from "./Make.vue?vue&type=template&id=77a62b63"
import script from "./Make.vue?vue&type=script&lang=js"
export * from "./Make.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports